import { msg } from 'gt-react';
import {
  createRoute,
  lazyRouteComponent,
  type AnyRoute,
} from '@tanstack/react-router';

const KeyboardShortcutsSettingsPage = lazyRouteComponent(
  () => import('../KeyboardShortcutsSettingsPage'),
  'KeyboardShortcutsSettingsPage',
);

// The user-settings layout is still declared in src/routes.tsx. Register it
// from there instead of importing routes.tsx, which would cycle.
let settingsUserLayoutRoute: AnyRoute | undefined;

export function attachSettingsUserLayout(route: AnyRoute) {
  settingsUserLayoutRoute = route;
}

export const Route = createRoute({
  getParentRoute: () => {
    if (!settingsUserLayoutRoute) {
      throw new Error(
        'Keyboard shortcuts route is missing its settings layout parent',
      );
    }
    return settingsUserLayoutRoute;
  },
  path: '/settings/user/keyboard-shortcuts',
  component: KeyboardShortcutsSettingsPage,
  loader: () => ({
    crumb: msg('Keyboard shortcuts', { context: 'page breadcrumb' }),
  }),
});
